/**
 * Utility functions for hierarchical/composable sequences
 */

/**
 * Checks if a participant name is a subsystem reference (starts with *)
 */
export function isSubsystemReference(participantName: string): boolean {
  return participantName.startsWith('*');
}

/**
 * Extracts the anchor name from a subsystem reference
 * Example: "*userService" => "userService"
 */
export function getAnchorName(participantName: string): string | null {
  if (!isSubsystemReference(participantName)) {
    return null;
  }
  return participantName.substring(1);
}

/**
 * Gets the display name for a participant
 * For subsystem references, removes the * prefix
 */
export function getDisplayName(participantName: string): string {
  if (isSubsystemReference(participantName)) {
    return participantName.substring(1);
  }
  return participantName;
}
